import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicCircleFileIdSelected({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <circle cx={28} cy={28} r={28} fill="#56A" opacity={0.88} />
      <path fill="#fff" d="M40 41V15a1 1 0 00-1-1H22l-6 6v21a1 1 0 001 1h22a1 1 0 001-1" />
      <path
        fill="#56A"
        fillRule="evenodd"
        d="M21.5 22a.5.5 0 00-.5.5v.7c0 .28.22.5.5.5h13a.5.5 0 00.5-.5v-.7a.5.5 0 00-.5-.5zm-.5 4.7c0-.28.22-.5.5-.5h13c.28 0 .5.22.5.5v.7a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5zm0 4.2c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v.7a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5z"
        clipRule="evenodd"
        opacity={0.88}
      />
      <path fill="#8F9DD6" fillRule="evenodd" d="M16 20l6-6v5a1 1 0 01-1 1z" clipRule="evenodd" />
      <circle cx={38} cy={37} r={9} fill="#8F9DD6" />
      <path
        fill="#fff"
        d="M35.01 33v8h-1.69v-8zm4.9 8h-2.84v-8h2.85q1.2 0 2.08.48.87.48 1.34 1.37t.48 2.14-.48 2.15q-.47.9-1.35 1.38-.87.48-2.09.48m-1.15-1.45h1.07q.75 0 1.26-.26.52-.27.78-.84t.26-1.46-.26-1.45a1.7 1.7 0 00-.77-.83 3 3 0 00-1.27-.26h-1.07z"
      />
    </svg>
  );
}

SvgPicCircleFileIdSelected.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicCircleFileIdSelected.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicCircleFileIdSelected svgRef={ref} {...props} />
));
export default ForwardRef;
